/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ConfigureProduct.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Sivateja.P(H27743)
 *
 * @Date                : Jul 29, 2019
 *
 * @Version      : Version 1.0
 *
 *  By            : Sivateja (H267743)
 * On            : Aug 08, 2019
 * Description   : implemented the tick icons for configure product (ASDS-906)
 *
 * By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : Connected to React Routing (ASDS-909)
 *
 * By            : H352615
 * On            : Aug 27, 2019
 * Description   : Add Loader for fetching features - ASDS-1084
 *
 * By            : Sivateja (H267743)
 * On            : Sept 19, 2019
 * Description   : implemented edit buttons funcationality in confirm-configuration tab (ASDS-1047)
 *
 * By            : SandeepRaja Batchu (E807238)
 * On            : Sep 20, 2019
 * Description   : Configure Features tab-Display Part Number & Feature -ASDS-1289
 * By            : H224423
 * On            : Sep 25, 2019
 * Description   : ASDS-411 Edit cart Item Aspire changes
 *
 * By            : SandeepRaja (E807238)
 * On            : Oct 9, 2019
 * Description   : ASDS-594: Bulk Configuration - Confirm Configuration
 *					- UI (Static)

 * By            : H224423
 * On            : Oct 03, 2019.
 * Description   : ASDS-1478 - Dancing loader issue fix. Removed unauthorised use of zIndex property.
 *
 * By            : h267743
 * On            : Oct 14, 2019.
 * Description   : ASDS-1477 - Removed the Generic loader, movied the same to configure fetures
 *
 * By            : Madhu Gali - H175591
 * On            : 18 Oct 2019
 * Description   : ASDS-1549
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes. Added properties for displaying product icon.
 *
 * By            : H224423
 * On            : 24 Oct 2019
 * Description   : ASDS-1256. Moved smaller functional components to separate files.
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Jan 9th, 2020
 * Description   : updated the code for ASDS-1081
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Feb 17th, 2020
 * Description   : updated the code Product Test cases - removed unused code
 *
 * By            : H422337
 * On            : 03 Nov 2020
 * Description   : ASDS-3823 - Aspire UI enhancements of Phase-2
 *
 * By            : H422337
 * On            : Nov 04, 2020
 * Description   : ASDS-3570 - UI Enhancements for Phase - II  with Forge API changes
 *
 * By            : H422337
 * On            : 03 Nov 2020
 * Description   : ASDS-3824 - Migration of DCE Endpoints to new Forge Environment API and UI enhancements of Phase-2
 *
 * By            : H422336
 * On            : Nov 7 2020
 * Description   : ASDS-3832 UI Enhancements for Phase-II
 *
 ******************************************************************************/

import * as React from 'react';
import { Modal, Button, Tab, Stepper, Grid, Notification } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './ConfigureProduct.css';
import SCMSerialNumbers from './addScmSerialNumbers';
import ConfigureFeature from './configureFeatures';
import { connect } from 'react-redux';
import ConfigureProductActions from '../redux/actions/configure-product-actions';
import ConfirmConfiguration from './ConfirmConfiguration';
import BulkConfigContent, { BulkConfigurationStepper } from '../BulkConfiguration/BulkConfiguration';
import { withRouter, RouteComponentProps, Redirect } from 'react-router-dom';
import routeConstants from '../constants/route-constants';
import CheckoutConstants, { CheckoutUILabels } from '../constants/checkout-constants';
import { ContactUsMessage } from '../Common/ContactUsMessage';
import { InLineLoader } from '../Loader/Loader';

interface ICondigureProductState {
    open: any;
    hasClickOut: boolean;
    counter: number;
    error: string;
    featuresError: any;
}

interface IConfigureProductProps {
    open: boolean;
    onCancel: any;
    productFeatureMasterData: any;
    getProductFeaturesMasterData: Function;
    productFeatures: IFeaure[];
    productName: string;
    totalPrice: any;
    addNewSerial: Function;
    updateSerial: Function;
    deleteSerial: Function;
    productSerialNumbers: ISerialNumber[];
    gotoPrevTab: any;
    gotoNextTab: any;
    activeTab: number;
    enableNextBtn: boolean;
    productId: string;
    redirectTo: string;
    isFeatureMasterDataFetching: boolean;
    gotoSCMSerialNumbersTab: Function;
    gotoConfigureFeaturesTab: Function;
    onMainTabToggle: Function;
    configTemplateLink: string;
    showAlertMsg: boolean;
    lastProdAddedToCart: string;
    isAddToCartSuccess: boolean;
    addProductToCartInProgress: boolean;
    tabActiveIndex: number;
}
interface IFeaure {
    partNumber: string;
    validity: string;
    unitPrice: string;
    extendedPrice: string;
    partNumberError: string;
    validityError: string;
    notes: string;
}

interface ISerialNumber {
    serialNumber: string;
}

// Function to return lable for primary button on configuration Modal
function PrimaryButtonLable(props: any) {
    if (props.activeTab === 3) {
        if (props.location.pathname === routeConstants.PURCHASE_SOFTWARE) {
            return CheckoutUILabels.CONFIGURATION_CONFIRM;
        }
        else {
            return CheckoutUILabels.CONFIGURATION_SAVE_BTN;
        }
    }
    else if (props.activeTab === 5) {
        return CheckoutUILabels.CONFIGURATION_CONFIRM;
    }
    else {
        return CheckoutUILabels.CONFIGURATION_NEXT;
    }
}


export function ConfigContent(props: any) {
    let cardContent;
    if (props.activeTab === 1) {
        cardContent = (
            <SCMSerialNumbers />
        );
    } else if (props.activeTab === 2) {
        cardContent = <ConfigureFeature />
    } else {
        cardContent = <ConfirmConfiguration />;

    }
    return cardContent;
}

export class ConfigureProduct extends React.Component<IConfigureProductProps & RouteComponentProps, ICondigureProductState> {
    constructor(props: IConfigureProductProps & RouteComponentProps) {
        super(props);
        this.state = {
            open: props.open,
            hasClickOut: false,
            counter: 0,
            error: '',
            featuresError: {
                errorKey: -1,
                partNumber: '',
                validity: '',
            },
        };
    }

    componentDidMount() {
        this.props.getProductFeaturesMasterData(this.props.productId);
    }

    render() {
        if (this.props.redirectTo) {  // based on this filed will be redirected to my cart page.
            return (
                <Redirect to={this.props.redirectTo} />
            );
        }
        return (
            // code to open modal
            <React.Fragment>
                {this.renderModal()}
            </React.Fragment>
        );
    }

    renderModal() {

        return (
            <Modal
                closeIcon={true}
                onClose={() => this.props.onCancel(this.props.location.pathname)}
                size="large"
                open={this.props.open}
                closeOnDimmerClick={this.state.hasClickOut}
                closeOnDocumentClick={this.state.hasClickOut}
                className="configure-product-modal"
            >
                <Modal.Header>
                    <div className="ca-modal-heading-text">
                        Configure Product
                    </div>
                    <div className="ca-modal-product-line">
                        <div className="ca-modal-product-icon">
                            <i className={CheckoutConstants.ASPIRE_PRODUCT_CLASSNAME} />
                        </div>
                        <span className="c-product-name-heading">{this.props.productName}</span>
                    </div>

                </Modal.Header>
                <div className="box">
                    {' '}
                    <Modal.Content>
                    {this.props.showAlertMsg && !this.props.isAddToCartSuccess &&
                            <div>
                                <Notification
                                    hasIcon={true}
                                    title={'Unable to add ' + this.props.lastProdAddedToCart + ' in your cart.'}
                                    severity="critical"
                                >
                                    <ContactUsMessage>Please try again by clicking on Confirm button. {CheckoutUILabels.IF_ISSUE_PERSISTS}</ContactUsMessage>
                                </Notification>
                            </div>
                        }
                        <div className="cp-modal-content">
                            <Tab className="cp-tab" activeIndex={this.props.tabActiveIndex} onTabChange={(activeIndex) => (this.props.onMainTabToggle(activeIndex))} >
                                <Tab.Pane title="Configuration" className="cp-config-tab">
                                    <div className="cp-config-tab-content">
                                        <Stepper ordered={true} className="stepperClass ca-stepper">
                                            <Stepper.Item
                                                title=" Add Serial Number"
                                                icon="document-user-profile"
                                                active={this.props.activeTab === 1}
                                                /*disabled={this.props.activeTab !== 1}*/
                                                iconRoot="common"
                                                completed={this.props.activeTab > 1}
                                            />
                                            <Stepper.Item
                                                title=" Configure Feature "
                                                active={this.props.activeTab === 2}
                                                disabled={this.props.activeTab < 2}
                                                iconRoot="common"
                                                icon="document-user-profile"
                                                completed={this.props.activeTab > 2}
                                            />
                                            <Stepper.Item
                                                title=" Confirm Configuration"
                                                active={this.props.activeTab === 3}
                                                disabled={this.props.activeTab !== 3}
                                                iconRoot="common"
                                                icon="document-confirm"
                                            />
                                        </Stepper>
                            {this.props.addProductToCartInProgress ?
                             <Grid>
                                <Grid.Row>
                                    <Grid.Column width={12} className="add-to-cart-loader">
                                        <InLineLoader text="Adding to Cart" loading={true} overlayColor="transparent">
                                         </InLineLoader>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid> :
                                        <ConfigContent
                                            activeTab={this.props.activeTab}
                                            totalPrice={this.props.totalPrice}
                                            productFeatures={this.props.productFeatures}
                                            gotoSCMSerialNumbersTab={this.props.gotoSCMSerialNumbersTab}
                                            gotoConfigureFeaturesTab={this.props.gotoConfigureFeaturesTab}
                                        />
                            }
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane title="Bulk Configuration" className="cp-bulk-tab">
                                    <div className="cp-bulk-tab-content">
                                        <BulkConfigurationStepper {...this.props} />
                                        {this.props.addProductToCartInProgress ?
                             <Grid>
                                <Grid.Row>
                                    <Grid.Column width={12} className="add-to-cart-loader">
                                        <InLineLoader text="Adding to Cart" loading={true} overlayColor="transparent">
                                         </InLineLoader>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid> :
                                        <BulkConfigContent {...this.props} />
    }
                                    </div>
                                </Tab.Pane>
                            </Tab>
                        </div>
                    </Modal.Content>
                </div>
                <Modal.Footer>
                    <div className="display-flex">
                        {/* if the user is in first step, then show cancel button, else show back button */}

                        {this.props.activeTab === 1 || this.props.activeTab === 4 ?
                            <Button
                                className="co-secondary-button"
                                type="secondary"
                                content="cancel"
                                onClick={() => this.props.onCancel(this.props.location.pathname)}
                            />
                            :
                            <Button
                                className="co-secondary-button"
                                type="secondary"
                                content="Back"
                                onClick={this.props.gotoPrevTab}
                            />
                        }
                        <Button
                            className="co-primary-button"
                            type="primary"
                            size="medium"
                            disabled={!this.props.enableNextBtn}
                            content={PrimaryButtonLable(this.props)}
                            onClick={this.props.gotoNextTab}
                        />
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

const mapDispatchToProps = {
    getProductFeaturesMasterData: ConfigureProductActions.getFeaturesMasterData,
    addNewSerial: ConfigureProductActions.addNewSerial,
    updateSerial: ConfigureProductActions.updateSerial,
    deleteSerial: ConfigureProductActions.deleteSerial,
    gotoNextTab: ConfigureProductActions.gotoNextTab,
    gotoPrevTab: ConfigureProductActions.gotoPrevTab,
    onCancel: ConfigureProductActions.onCancel,
    gotoSCMSerialNumbersTab: ConfigureProductActions.gotoSCMSerialNumbersTab,
    gotoConfigureFeaturesTab: ConfigureProductActions.gotoConfigureFeaturesTab,
    onMainTabToggle: ConfigureProductActions.onMainTabToggle,
};

function mapStateToProps(state) {
    return {
        productFeatureMasterData: state.configProductData.payload.featuresMasterData,
        productFeatures: state.configProductData.payload.productFeatures,
        productSerialNumbers: state.configProductData.payload.serialNumbers,
        totalPrice: state.configProductData.payload.totalPrice,
        activeTab: state.configProductData.payload.activeTab,
        enableNextBtn: state.configProductData.payload.enableNextBtn,
        redirectTo: state.configProductData.payload.redirectTo,
        isFeatureMasterDataFetching: state.configProductData.payload.isFeatureMasterDataFetching,
        configTemplateLink: state.configProductData.payload.product.config === undefined ? '' : state.configProductData.payload.product.config.template,
        showAlertMsg: state.productAlertData.payload.showAlertMsg,
        lastProdAddedToCart: state.productAlertData.payload.lastProdAddedToCart,
        isAddToCartSuccess: state.productAlertData.payload.isAddToCartSuccess,
        addProductToCartInProgress: state.productAlertData.payload.addProductToCartInProgress,
        tabActiveIndex: state.configProductData.payload.activeMainTabIndex
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ConfigureProduct));
